import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import PlayButton from '../play-button';

const VideoPlaceholderContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: var(--color-white);
    border-radius: 4px;
    box-shadow: var(--shadow-6);
    padding: 0 16px 16px 16px;
    box-sizing: border-box;
`;

export const InfoContainer = styled.div`
    display: flex;
    height: 32px;
    align-items: center;
    justify-content: space-between;
`;

export const ThumbContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    max-width: 100%;
    height: calc(100% - 32px);
    cursor: pointer;

    &[disabled] {
        cursor: initial;
    }
`;

export const ThumbFilter = styled.div`
    background-color: #333333;
    opacity: 0.7;
    width: 100%;
    height: 100%;
    position: absolute;
`;

export const Thumb = styled.object`
    position: absolute;
    display: inline-block;
    width: 100%;
    height: 100%;
`;

const ThumbFallback = styled.img`
    position: absolute;
    display: inline-block;
    width: 100%;
    height: 100%;
`;

export const InfoText = styled.p`
    height: 16px;
    color: rgb(103, 107, 111);
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.37px;
    line-height: 16px;
`;

export const TitleText = styled(InfoText)`
    max-width: 80%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const VideoPlaceholder = ({ title, duration, imageSource, imageSourceFallback, onClick, disabled }) => {
    return (
        <VideoPlaceholderContainer>
            <InfoContainer>
                <TitleText>{title}</TitleText>
                <InfoText>{duration}</InfoText>
            </InfoContainer>
            <ThumbContainer onClick={onClick} disabled={disabled}>
                <Thumb data={imageSource} type="image/jpg">
                    <ThumbFallback src={imageSourceFallback} alt="Video placeholder" />
                </Thumb>
                <ThumbFilter />
                <PlayButton onClick={onClick} disabled={disabled} />
            </ThumbContainer>
        </VideoPlaceholderContainer>
    );
};

VideoPlaceholder.propTypes = {
    title: PropTypes.string,
    duration: PropTypes.string,
    imageSource: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    imageSourceFallback: PropTypes.string,
    disabled: PropTypes.bool,
};

export default VideoPlaceholder;
